import React from 'react';

import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

import { useCheckoutLoadingState } from '../../hooks';
import { useCheckoutValidation } from '../../hooks/use-checkout-validation';

interface ErrorTextProps {
  testID?: string;
}

export const ErrorText: React.FC<ErrorTextProps> = ({ testID = 'checkout-error-text' }) => {
  const { validate } = useCheckoutValidation();
  const checkoutErrors = validate();
  const { isCheckoutLoading } = useCheckoutLoadingState();

  if (checkoutErrors.length === 0 || isCheckoutLoading) {
    return null;
  }

  const errors = checkoutErrors.filter(error => error.placement === 'footer');

  if (errors.length === 1) {
    const error = errors[0];
    const displayMessage = error.message || (error.messageId ? t(error.messageId) : '');

    return (
      <Typography style={styles.errorText} testID={testID}>
        {displayMessage}
      </Typography>
    );
  }

  // If multiple errors, display them as a list
  return (
    <View testID={testID}>
      {errors.map((error, index) => {
        const displayMessage = error.message || (error.messageId ? t(error.messageId) : '');

        return (
          <Typography key={error.type} style={styles.errorText}>
            • {displayMessage}
          </Typography>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  errorText: {
    color: primitive.$alertRed,
    fontFamily: primitive.fontFamily.$body,
    fontSize: primitive.fontSizes.xs,
    marginBottom: 4,
    textAlign: 'center',
    paddingVertical: 8,
  },
});
